// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9305012","677":"9dacbc3c"}[chunkId] + ".chunk.js";
};